import { render } from "./ShowCard.vue?vue&type=template&id=e9021a60&scoped=true"
import script from "./ShowCard.vue?vue&type=script&lang=js"
export * from "./ShowCard.vue?vue&type=script&lang=js"

import "./ShowCard.vue?vue&type=style&index=0&id=e9021a60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9021a60"]])

export default __exports__